import { t } from 'i18next';
import { Icon } from '../icon/icon.spark';
import type { ExternalLinkProps } from './types';

export function ExternalLink({ link, showIcon, children, ariaLabel }: ExternalLinkProps) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 rounded-sm font-medium text-spark-primary-accent hover:cursor-pointer hover:brightness-125 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-spark-primary-accent focus-visible:ring-offset-2 focus-visible:ring-offset-spark-surface"
    >
      {/* `ariaLabel` is a hidden text node rather than `aria-label` so it composes with the
          new-tab hint below instead of overriding it. */}
      {ariaLabel && <span className="sr-only">{ariaLabel}</span>}
      {children}
      {showIcon && <Icon name="externalLink" />}
      <span className="sr-only">{t('aria:opens_new_tab')}</span>
    </a>
  );
}
